import {MainButton} from 'shared/components/drawer-option/styles';
import styled from 'styled-components';

interface ContainerProps {
  hideDrawer: boolean;
  floating: boolean;
}

interface OptionProps {
  active?: number;
}

export const Container = styled.div<ContainerProps>`
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  height: 100vh;

  @media (max-width: 975px) {
    grid-template-columns: 1fr;
  }

  ${(props) =>
    props.floating &&
    `  
    top: 0;
    position: fixed;
    z-index: 1000;
  `}
`;

export const SideBar = styled.aside`
  width: 260px;
  height: 100vh;
  position: fixed;
  background-color: ${(props) => props.theme.colors.contrast};

  @media (max-width: 975px) {
    display: none;
  }
`;

export const Navigation = styled.nav`
  display: flex;
  height: calc(100vh - 60px);
  align-items: center;
  flex-direction: column;
  position: sticky;
  top: 0;
  padding: 10px;
  padding-bottom: 0;
  padding-right: 5px;
`;

export const LogoBox = styled.div`
  height: 64px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NavigationOptions = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 15px;
`;

export const Body = styled.div<ContainerProps>`
  max-width: 100vw;
  padding-left: ${(props) => (props.hideDrawer ? 0 : 260)}px;
  background-color: ${(props) => props.theme.colors.background};
  box-shadow: inset rgba(99, 99, 99, 0.2) 2px 2px 8px 0px;
`;

export const Content = styled.div`
  overflow-x: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;

  @media (max-width: 975px) {
    width: 100vw;
    padding: 20px 15px;
  }
`;

export const Card = styled.div`
  flex: 1;
  border-radius: 5px;
`;

export const Row = styled.div<OptionProps>`
  gap: 10px;
  display: flex;
  align-items: center;
  padding: 10px 15px;
  border-radius: 8px;
  cursor: pointer;

  ${(props) => props.active && 'background-color: #2c2c2c;'}

  &:hover {
    background-color: ${(props) => props.theme.colors.primary};
  }

  svg {
    font-size: 22px;
    color: ${(props) => props.theme.colors.text};
  }
`;

export const Option = styled.span`
  display: block;
  color: ${(props) => props.theme.colors.text};
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  font-weight: 400;
  height: 20px;
`;

export const Footer = styled.div`
  width: calc(100% - 20px);
  margin-left: 10px;
  height: 60px;

  svg {
    font-size: 26px;
  }

  div {
    width: 100%;
    padding: 8px 10px;
  }
`;
